import * as React from "react";
import {
  Modal,
  Typography,
  Box,
  Container,
  TextField,
  CssBaseline,
  Button,
  Avatar,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
  FormControl,
  CircularProgress,
  Chip,
  Paper,
} from "@mui/material";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { notification } from "antd";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {
  MainInputLabel,
  main_button,
  centered_flex_box,
  sec_button,
  confirm_button,
  reject_button,
  ter_button,
  MainInput,
} from "../../../app/components/Styles";
import {
  generateTickets,
  generateTicketsQRs,
} from "../../../app/store/actions/adminActions";
import ReactFileReader from "react-file-reader";
import Upload from "@mui/icons-material/Upload";
import Download from "@mui/icons-material/Download";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import download from "downloadjs";
import * as XLSX from 'xlsx';
import PopperButton from "../../../app/components/PopperButton";
import { motion } from "framer-motion";

export const GenerateTicketsModal = ({
  open,
  handleClose,
  event,
  wait,
  generateTickets,
  generateTicketsQRs,
  action,
  setAction,
}) => {
  const [file, setFile] = React.useState(null);
  const [entrantNumber, setEntrantNumber] = React.useState(0);
  const [category, setCategory] = React.useState("");
  const id = useParams().id;

  const handleDeleteFile = () => {
    setFile(null);
  };

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  const handleSubmit = (event) => {
    const { selected, index } = event;
    var reader = new FileReader();
    if (file) {
      reader.readAsArrayBuffer(file);
      reader.onload = async (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonData = XLSX.utils.sheet_to_json(firstSheet, { 
            raw: false,
            defval: '',
            blankrows: false
          });

          const info = {
            eventId: id,
            data: jsonData.filter(
              (info) => info.name && info.name.trim() !== ""
            ),
            category,
          };

          switch (index) {
            case 0:
              generateTickets({ ...info, download: "false", sendMails: "true" });
              break;
            case 1:
              generateTickets(info);
              break;
            case 2:
              generateTickets({ ...info, sendMails: "true" });
              break;
            case 3:
              generateTicketsQRs(info);
              break;
            case 4:
              generateTicketsQRs({ ...info, sendMails: "true" });
              break;
            default:
              break;
          }
          setEntrantNumber(jsonData.length);
        } catch (err) {
          console.error('Error processing file:', err);
          notification.error({ message: "Error processing Excel file. Please check the file format." });
        }
      };
    } else {
      notification.error({ message: "Please Upload a valid Excel file" });
    }
  };

  const handleFiles = (files) => {
    setFile(files[0]);
  };

  return (
    <Modal 
      open={open} 
      onClose={handleClose}
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          backdropFilter: 'blur(4px)'
        }
      }}
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '95vw', sm: '600px' },
        maxWidth: '95vw',
        maxHeight: '90vh',
        outline: 'none'
      }}>
        {wait.isLoading && (
          <Paper
            elevation={8}
            sx={{
              ...centered_flex_box,
              minHeight: "50vh",
              p: 4,
              borderRadius: 3,
              backgroundColor: 'var(--platform-surface)',
              border: '1px solid #e0e0e0'
            }}
          >
            <CircularProgress 
              size={60}
              sx={{ 
                color: "var(--primaryPurple)",
                mb: 2
              }} 
            />
            <Typography 
              variant="h6" 
              sx={{ 
                color: "var(--primaryPurple)",
                fontFamily: 'TickitOne, Helvetica, Arial, sans-serif'
              }}
            >
              Generating tickets...
            </Typography>
          </Paper>
        )}
        {!wait.isLoading && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 50 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
          >
            <Paper
              elevation={12}
              sx={{
                p: { xs: 2, sm: 5 },
                borderRadius: 4,
                backgroundColor: 'var(--platform-surface)',
                border: '1px solid #e0e0e0',
                boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                maxHeight: '90vh',
                overflowY: 'auto',
                '&::-webkit-scrollbar': {
                  width: '6px'
                },
                '&::-webkit-scrollbar-track': {
                  backgroundColor: '#f1f1f1',
                  borderRadius: '3px'
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'var(--primaryPurple)',
                  borderRadius: '3px'
                }
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Avatar 
                  sx={{ 
                    m: 2, 
                    bgcolor: "var(--primaryPurple)",
                    width: { xs: 56, sm: 80 },
                    height: { xs: 56, sm: 80 },
                    boxShadow: '0 8px 24px rgba(95, 53, 184, 0.3)',
                    '& .MuiSvgIcon-root': {
                      fontSize: '2.5rem',
                      color: 'white'
                    }
                  }}
                >
                  <LocalActivityIcon />
                </Avatar>
                <Typography 
                  component="h1" 
                  variant="h4" 
                  sx={{ 
                    mb: 4,
                    fontSize: { xs: '1.4rem', sm: '2.125rem' },
                    color: 'var(--primaryPurple)',
                    fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                    fontWeight: 'bold',
                    textAlign: 'center'
                  }}
                >
                  Generate Tickets
                </Typography>
                <Typography 
                  variant="body1" 
                  sx={{ 
                    mb: 3,
                    color: 'var(--tickit-gray500)',
                    fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                    textAlign: 'center',
                    maxWidth: '400px'
                  }}
                >
                  Upload an Excel file with attendee data to automatically generate tickets
                </Typography>

                <Button
                  fullWidth
                  variant="outlined"
                  size="large"
                  startIcon={<Download />}
                  onClick={() =>
                    download(
                      "https://tickit-media.s3.eu-central-1.amazonaws.com/files/tickets-sample.xlsx"
                    )
                  }
                  sx={{ 
                    mb: 3,
                    borderRadius: 3,
                    py: 1.5,
                    textTransform: 'none',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    borderColor: '#e0e0e0',
                    color: 'var(--tickit-gray500)',
                    fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                    '&:hover': {
                      borderColor: 'var(--primaryPurple)',
                      backgroundColor: 'rgba(95, 53, 184, 0.04)',
                      color: 'var(--primaryPurple)'
                    }
                  }}
                >
                  Download Excel Sample
                </Button>

                <Box
                  component="form"
                  onSubmit={handleSubmit}
                  sx={{ width: '100%', mt: 2 }}
                >
                  <MainInput
                    margin="normal"
                    autoFocus
                    fullWidth
                    select
                    labelId="num-label"
                    id="category"
                    label="Category"
                    name="category"
                    value={category}
                    onChange={({ target }) => setCategory(target.value)}
                    sx={{
                      mb: 3,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        backgroundColor: 'var(--platform-surface)',
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'var(--primaryPurple)',
                          borderWidth: '2px'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'var(--primaryPurple)',
                          borderWidth: '2px'
                        }
                      },
                      '& .MuiInputLabel-root': {
                        color: 'var(--primaryPurple)',
                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                      }
                    }}
                  >
                    {event?.categories?.map((cat) => (
                      <MenuItem value={cat.category}>
                        {cat.category} - Category
                      </MenuItem>
                    ))}
                  </MainInput>

                  <Box sx={{ mt: 2, mb: 3 }}>
                    <ReactFileReader handleFiles={handleFiles} fileTypes={[".xlsx", ".xls"]}>
                      <Button 
                        fullWidth 
                        variant="outlined"
                        size="large"
                        startIcon={<Upload />}
                        sx={{ 
                          borderRadius: 3,
                          py: 1.5,
                          textTransform: 'none',
                          fontSize: '1rem',
                          fontWeight: 'bold',
                          borderColor: '#e0e0e0',
                          color: 'var(--tickit-gray500)',
                          fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                          '&:hover': {
                            borderColor: 'var(--primaryPurple)',
                            backgroundColor: 'rgba(95, 53, 184, 0.04)',
                            color: 'var(--primaryPurple)'
                          }
                        }}
                      >
                        Upload Excel File
                      </Button>
                    </ReactFileReader>
                    {file && (
                      <Chip 
                        label={file.name} 
                        onDelete={handleDeleteFile}
                        sx={{ 
                          mt: 2,
                          borderRadius: 2,
                          backgroundColor: 'rgba(95, 53, 184, 0.1)',
                          color: 'var(--primaryPurple)',
                          fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                          '& .MuiChip-deleteIcon': {
                            color: 'var(--primaryPurple)',
                            '&:hover': {
                              color: 'var(--secPurple)'
                            }
                          }
                        }}
                      />
                    )}
                  </Box>

                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },
                    justifyContent: 'center', 
                    gap: 3,
                    mt: 4,
                    pt: 3,
                    borderTop: '1px solid #e0e0e0',
                    '& .MuiButton-root': {
                      width: { xs: '100%', sm: 'auto' }
                    }
                  }}>
                    <Button
                      onClick={handleClose}
                      variant="outlined"
                      size="large"
                      sx={{ 
                        borderRadius: 3,
                        px: 4,
                        py: 1.5,
                        textTransform: 'none',
                        fontSize: { xs: '1rem', sm: '1.1rem' },
                        fontWeight: 'bold',
                        borderColor: '#e0e0e0',
                        color: 'var(--tickit-gray500)',
                        fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                        '&:hover': {
                          borderColor: '#e0e0e0',
                          backgroundColor: '#f5f5f5',
                          color: '#333'
                        }
                      }}
                    >
                      Cancel
                    </Button>
                    <PopperButton
                      sx={{ 
                        borderRadius: 3,
                        px: 4,
                        py: 1.5,
                        textTransform: 'none',
                        fontSize: { xs: '1rem', sm: '1.1rem' },
                        fontWeight: 'bold',
                        backgroundColor: 'var(--primaryPurple)',
                        fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                        boxShadow: '0 4px 16px rgba(95, 53, 184, 0.3)',
                        '&:hover': {
                          backgroundColor: 'var(--secPurple)',
                          boxShadow: '0 6px 20px rgba(95, 53, 184, 0.4)',
                          transform: 'translateY(-2px)'
                        },
                        transition: 'all 0.3s ease'
                      }}
                      options={[
                        "Send Emails Only",
                        "Generate Full Tickets Only",
                        "Generate Full Tickets & Send Emails",
                        "Generate QR Codes Only",
                        "Generate QR Codes & Send Emails",
                      ]}
                      onClick={handleSubmit}
                    />
                  </Box>
                </Box>
              </Box>
            </Paper>
          </motion.div>
        )}
      </Box>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  wait: state?.wait,
});

const mapDispatchToProps = { generateTickets, generateTicketsQRs };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GenerateTicketsModal);
